<template>
  <base-content :data="data"
    :index="index"
    :headerClass="`thumbnail-block clearfix`"
    :footerClass="getFooterClass"
    view="list"
  >
    <template #card-header>
      <researcher-thumbnail :researcher="data"
        :maxChars="2"
        disableLink
        class="avatar">
      </researcher-thumbnail>

      <partial-title :title="fullName" :link="link" class="name" />
    </template>

    <template #card-body>
      <div v-if="data.ranking_h_index" class="t-sm">
        <span class="mr-3"><span class="t-500"><i>h</i>-index: </span> {{ data.ranking_h_index }}</span>
        <span class="mr-3"><span class="t-500">i10-index: </span> {{ data.ranking_i10_index || 0 }}</span>
      </div>
      <partial-description v-if="about"
        :description="about"
        :isLoading="highlightsLoading">
      </partial-description>

      <ul v-if="!isEmpty(matches)"  :class="{ 'mt-2': about }">
        <matches :matches="matches" view="list" />
      </ul>
    </template>

    <template #card-footer>
      <partial-research-groups v-if="!isEmpty(researchGroups)"
        :researchGroups="researchGroups"
        :highlights="highlightResearchGroups">
      </partial-research-groups>

      <partial-organisations v-if="!isEmpty(organisations)"
        :organisations="organisations"
        :highlights="highlightOrganisations"
        :lineClamp="1">
      </partial-organisations>
    </template>

    <template #card-actions>
      <slot name="actions"></slot>
    </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/researcher'

import BaseContent from '@/components/search/results/BaseContent'
import ResearcherThumbnail from '@/components/researcher/Thumbnail'
import PartialDescription from '@/components/search/results/partials/Description'
import PartialTitle from '@/components/search/results/partials/Title'
import PartialResearchGroups from '@/components/search/results/partials/ResearchGroups'
import PartialOrganisations from '@/components/search/results/partials/Organisations'
import Matches from '@/components/search/results/partials/Matches'

export default {
  name: 'researcherResultList',
  mixins: [processing],
  components: {
    Matches,
    ResearcherThumbnail,
    PartialTitle,
    PartialDescription,
    PartialResearchGroups,
    PartialOrganisations,
    BaseContent
  },
  computed: {
    getFooterClass () {
      return this.isEmpty(this.organisations) && this.isEmpty(this.researchGroups) ? 'd-none' : ''
    }
  }
}
</script>
